import React from 'react';
import { ConfigProvider } from '../config/config.provider';
import AppInternal from './app.internal';
import { AppProviderProps, Provider } from './app.types';

export const AppProvider: Provider = ({ configSource, onLoading, onError, children }: AppProviderProps) => {
  console.info('Inicializando o AppProvider');
  return (
    <ConfigProvider source={configSource} onLoading={onLoading} onError={onError}>
      <AppInternal onLoading={onLoading}>{children}</AppInternal>
    </ConfigProvider>
  );
};
